(ns shared.core.amelia-light.components.sidebar
  (:require ["@up/base-ui/components/ui/sidebar" :refer [SidebarProvider
                                                         Sidebar
                                                         SidebarContent
                                                         SidebarHeader
                                                         SidebarFooter
                                                         SidebarGroup
                                                         SidebarGroupLabel
                                                         SidebarMenu
                                                         SidebarMenuItem
                                                         SidebarMenuButton
                                                         SidebarMenuSub
                                                         SidebarMenuSubItem
                                                         SidebarMenuSubButton
                                                         SidebarTrigger]]))

(defn up-sidebar-provider [& args] (into [:> SidebarProvider] args))
(defn up-sidebar [& args] (into [:> Sidebar] args))
(defn up-sidebar-content [& args] (into [:> SidebarContent] args))
(defn up-sidebar-header [& args] (into [:> SidebarHeader] args))
(defn up-sidebar-footer [& args] (into [:> SidebarFooter] args))
(defn up-sidebar-group [& args] (into [:> SidebarGroup] args))
(defn up-sidebar-group-label [& args] (into [:> SidebarGroupLabel] args))
(defn up-sidebar-menu [& args] (into [:> SidebarMenu] args))
(defn up-sidebar-menu-item [& args] (into [:> SidebarMenuItem] args))
(defn up-sidebar-menu-button [& args] (into [:> SidebarMenuButton] args))
(defn up-sidebar-menu-sub [& args] (into [:> SidebarMenuSub] args))
(defn up-sidebar-menu-sub-item [& args] (into [:> SidebarMenuSubItem] args))
(defn up-sidebar-menu-sub-button [& args] (into [:> SidebarMenuSubButton] args))
(defn up-sidebar-trigger [& args] (into [:> SidebarTrigger] args))
